var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar2Line(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8745 2.625H18.3745C18.6066 2.625 18.8291 2.71719 18.9932 2.88128C19.1573 3.04538 19.2495 3.26794 19.2495 3.5V17.5C19.2495 17.7321 19.1573 17.9546 18.9932 18.1187C18.8291 18.2828 18.6066 18.375 18.3745 18.375H2.62451C2.39245 18.375 2.16989 18.2828 2.00579 18.1187C1.8417 17.9546 1.74951 17.7321 1.74951 17.5V3.5C1.74951 3.26794 1.8417 3.04538 2.00579 2.88128C2.16989 2.71719 2.39245 2.625 2.62451 2.625H6.12451V0.875H7.87451V2.625H13.1245V0.875H14.8745V2.625ZM17.4995 9.625H3.49951V16.625H17.4995V9.625ZM13.1245 4.375H7.87451V6.125H6.12451V4.375H3.49951V7.875H17.4995V4.375H14.8745V6.125H13.1245V4.375ZM5.24951 11.375H6.99951V13.125H5.24951V11.375ZM9.62451 11.375H11.3745V13.125H9.62451V11.375ZM13.9995 11.375H15.7495V13.125H13.9995V11.375Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar2Line);
export default __webpack_public_path__ + "static/media/calendar-2-line.ff463c91.svg";
export { ForwardRef as ReactComponent };